import type { SxStyle } from '@aibees/shared/theme';

interface ButtonProps {
  open?: boolean;
  isSmall?: boolean;
}

export const root: SxStyle = {};
